var map = {
	"./green-coconut.jpg": "8a4e",
	"./guava.jpg": "ee34",
	"./papaya.jpg": "69d7",
	"./pineapple.jpg": "6ba7",
	"./pomegranate.jpg": "4ce7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "addf";